// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"232":"96fc4ccf","266":"9e9bc8f7"}[chunkId] + ".chunk.js";
};